"use strict";

exports.__esModule = true;
var _DeviceValueColorSource = require("./DeviceValueColorSource");
Object.keys(_DeviceValueColorSource).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceValueColorSource[key]) return;
  exports[key] = _DeviceValueColorSource[key];
});